import type { ReviewCardDto } from './types';
import { reviewCardUrlSource } from './reviewCardSource';

export const REVIEW_SOURCE_PARAM = 'source';
export const REVIEW_CARD_PARAM = 'card';
export const REVIEW_PUZZLE_PARAM = 'puzzle';

export type ReviewCardSearchParams = {
  source: string | null;
  card: string | null;
  puzzle: string | null;
};

export function parseReviewCardSearch(search: string): ReviewCardSearchParams {
  const params = new URLSearchParams(search);
  return {
    source: params.get(REVIEW_SOURCE_PARAM),
    card: params.get(REVIEW_CARD_PARAM),
    puzzle: params.get(REVIEW_PUZZLE_PARAM),
  };
}

export function buildReviewCardSearch(card: ReviewCardDto | null): string {
  if (!card) {
    return '';
  }

  const params = new URLSearchParams();
  params.set(REVIEW_SOURCE_PARAM, reviewCardUrlSource(card));
  params.set(REVIEW_CARD_PARAM, card.cardId);
  if (card.kind === 'puzzle') {
    params.set(REVIEW_PUZZLE_PARAM, card.puzzleId);
  }
  return params.toString();
}

/** Merge review-card params into existing search params (replace mode). */
export function mergeReviewCardSearchParams(
  prev: URLSearchParams,
  card: ReviewCardDto | null,
): URLSearchParams {
  const next = new URLSearchParams(prev);
  next.delete(REVIEW_SOURCE_PARAM);
  next.delete(REVIEW_CARD_PARAM);
  next.delete(REVIEW_PUZZLE_PARAM);

  if (!card) {
    return next;
  }

  next.set(REVIEW_SOURCE_PARAM, reviewCardUrlSource(card));
  next.set(REVIEW_CARD_PARAM, card.cardId);
  if (card.kind === 'puzzle') {
    next.set(REVIEW_PUZZLE_PARAM, card.puzzleId);
  }
  return next;
}
